
















































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";

import { Match, Token } from "@/types";
import BaseToken from "@/components/BaseToken.vue";
import BaseTab from "@/components/BaseTab.vue";
import MatchedDocument from "@/components/MatchedDocument.vue";
import DocumentSummary from "@/components/DocumentSummary.vue";
import TimelineContainer from "@/components/timeline/TimelineContainer.vue";

@Component({
  components: {
    DocumentSummary,
    MatchedDocument,
    BaseTab,
    BaseToken,
    TimelineContainer
  }
})
export default class DocumentAnalysis extends Vue {
  private type: string = "1";

  @Prop({ default: null })
  private selectedType!: string | null;

  private types: [string, string][] = [
    ["1", "Conditions & Symptoms"],
    ["7", "Procedures"],
    ["4", "Labs & Vitals"],
    ["6", "Medications"],
    ["15", "Misc"]
  ];

  @State("text")
  private text!: string;

  @Getter("matches/parsed")
  private indexed!: (type: string) => Match[];

  @Getter("matches/flatten")
  private flatten!: Match[];

  @Action("details/update")
  show!: (value: Match) => void;

  @Watch("selectedType")
  onSelectedTypeUpdate() {
    if (this.selectedType) {
      this.type = this.selectedType;
    }
  }
}
